<template>
  <div class="main__guest-listing container main--sticky-bottom">
    <el-collapse ref="formRoot" v-model="activeCollapseIndexes">
      <el-collapse-item
        v-for="(contact, index) in contacts"
        :key="contact.contactID"
        :name="index"
        class="el-collapse-item--guest"
      >
        <!--<div class="label-mandatory">fields with <span class="indicator-mandatory">*</span> are mandatory</div>-->
        <template slot="title" class="title">
          <span class="guest-number">GUEST {{ index + 1 }} /</span>
          {{ getFullName(contact) }}

          <progress-bar
            :is-mini="true"
            :percentage="getProgressedPercentage(contact)"
          />
        </template>
        <el-form
          :ref="'formValidate' + contact.contactID"
          :model="contact"
          :rules="ruleValidate"
          label-position="top"
        >
          <section>
            <div class="guest-helper">Fields marked with * are mandatory</div>
            <el-row :gutter="16">
              <el-col :span="4">
                <el-form-item label="Title" prop="title">
                  <span slot="label">Salutation</span>
                  <v-select
                    :clearable="false"
                    :options="selectTitles"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="contact.title"
                    label="label"
                    ref="salutation"
                    @input="onInputChange(contact.contactID, 'title', $event)"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <span slot="label"
                    >Prefer to be addressed as
                    <i class="el-form-item--emphasis">(optional)</i></span
                  >
                  <el-input
                    :value="contact.nickname"
                    @input="
                      onInputChange(contact.contactID, 'nickname', $event)
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="4">
                <el-form-item label="First name" prop="firstName">
                  <el-input
                    :value="contact.firstName"
                    @input="
                      onInputChange(contact.contactID, 'firstName', $event)
                    "
                  />
                  <div class="small-note">as per passport</div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <span slot="label"
                    >Middle name
                    <i class="el-form-item--emphasis">(optional)</i></span
                  >
                  <el-input
                    :value="contact.middleName"
                    @input="
                      onInputChange(contact.contactID, 'middleName', $event)
                    "
                  />
                  <div class="small-note">as per passport</div>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="Last / Family name" prop="lastName">
                  <el-input
                    :value="contact.lastName"
                    @input="
                      onInputChange(contact.contactID, 'lastName', $event)
                    "
                  />
                  <div class="small-note">as per passport</div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Date of birth" prop="dateOfBirth">
                  <el-row :gutter="16">
                    <el-col :span="8">
                      <v-select
                        v-model="modelDateOfBirthDays[contact.contactID]"
                        :clearable="false"
                        :options="selectDateDays"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            'dateOfBirthDate',
                            $event,
                            'dateOfBirth',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="modelDateOfBirthMonths[contact.contactID]"
                        :clearable="false"
                        :options="selectDateMonths"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            'dateOfBirthMonth',
                            $event,
                            'dateOfBirth',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="modelDateOfBirthYears[contact.contactID]"
                        :clearable="false"
                        :options="selectDateYears"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            'dateOfBirthYear',
                            $event,
                            'dateOfBirth',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item prop="email">
                  <span slot="label"
                    >Email
                    <i class="el-form-item--emphasis">(optional)</i></span
                  >
                  <el-input
                    :value="contact.email"
                    type="email"
                    @input="onInputChange(contact.contactID, 'email', $event)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="phone">
                  <span slot="label"
                    >Contact number
                    <i class="el-form-item--emphasis">(optional)</i></span
                  >
                  <el-input
                    :value="contact.phone"
                    placeholder="eg: +1-234-457-8900"
                    @input="onInputChange(contact.contactID, 'phone', $event)"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item
                  label="Country of residence"
                  prop="mainMailingCountry"
                >
                  <v-select
                    :clearable="false"
                    :filter-by="filterCountry"
                    :options="selectCountries"
                    :reduce="(item) => item.value"
                    :value="contact.mainMailingCountry"
                    filterable
                    label="label"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'mainMailingCountry',
                        $event,
                      )
                    "
                    @visible-change="resetFilterCountry"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Nationality" prop="nationality">
                  <v-select
                    :clearable="false"
                    :filter-by="filterCountry"
                    :options="selectCountries"
                    :reduce="(item) => item.value"
                    :value="contact.nationality"
                    filterable
                    label="label"
                    @input="
                      onInputChange(contact.contactID, 'nationality', $event)
                    "
                    @visible-change="resetFilterCountry"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="Gender" prop="gender">
                  <v-select
                    :clearable="false"
                    :options="selectGenders"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="contact.gender"
                    filterable
                    label="label"
                    @input="onInputChange(contact.contactID, 'gender', $event)"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="16"
              v-if="!canShowPeruvianNationalIDField(contact)"
            >
              <el-col :span="6">
                <el-form-item label="Passport number" prop="passportNumber">
                  <el-input
                    :value="contact.passportNumber"
                    @input="
                      onInputChange(contact.contactID, 'passportNumber', $event)
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="Passport issuing country"
                  prop="passportIssuingCountry"
                >
                  <v-select
                    :clearable="false"
                    :filter-by="filterCountry"
                    :options="selectCountries"
                    :reduce="(item) => item.value"
                    :value="contact.passportIssuingCountry"
                    filterable
                    label="label"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'passportIssuingCountry',
                        $event,
                      )
                    "
                    @visible-change="resetFilterCountry"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Passport expiry date"
                  prop="passportExpiryDate"
                >
                  <!--<el-date-picker type="date"-->
                  <!--:value="contact.passportExpiryDate"-->
                  <!--style="width: 100%"-->
                  <!--placeholder="Select date"-->
                  <!--@input="onInputChange(contact.contactID, 'passportExpiryDate', $event)"/>-->

                  <el-row :gutter="16">
                    <el-col :span="8">
                      <v-select
                        v-model="modelPassportExpiryDateDays[contact.contactID]"
                        :clearable="false"
                        :options="selectDateDays"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportExpiryDateDate',
                            $event,
                            'passportExpiryDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="
                          modelPassportExpiryDateMonths[contact.contactID]
                        "
                        :clearable="false"
                        :options="selectDateMonths"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportExpiryDateMonth',
                            $event,
                            'passportExpiryDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="
                          modelPassportExpiryDateYears[contact.contactID]
                        "
                        :clearable="false"
                        :options="selectDateExpiryYears"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportExpiryDateYear',
                            $event,
                            'passportExpiryDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" v-if="canShowPeruvianNationalIDField(contact)">
              <el-col :span="6">
                <el-form-item
                  label="Peruvian National ID"
                  prop="nationalIdNumber"
                >
                  <el-input
                    :value="contact.nationalIdNumber"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'nationalIdNumber',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="!booking.isAmazonCruise" :gutter="16">
              <el-col :span="12">
                <el-form-item
                  label="Passport issued date"
                  prop="passportIssueDate"
                >
                  <el-row :gutter="16">
                    <el-col :span="8">
                      <v-select
                        v-model="modelPassportIssueDateDays[contact.contactID]"
                        :clearable="false"
                        :options="selectDateDays"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportIssueDateDate',
                            $event,
                            'passportIssueDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="
                          modelPassportIssueDateMonths[contact.contactID]
                        "
                        :clearable="false"
                        :options="selectDateMonths"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportIssueDateMonth',
                            $event,
                            'passportIssueDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                    <el-col :span="8">
                      <v-select
                        v-model="modelPassportIssueDateYears[contact.contactID]"
                        :clearable="false"
                        :options="selectDateYears"
                        :reduce="(item) => item.value"
                        filterable
                        label="label"
                        @input="
                          onInputDateChange(
                            contact.contactID,
                            ' passportIssueDateYear',
                            $event,
                            'passportIssueDate',
                          )
                        "
                      >
                      </v-select>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </el-row>

            <section>
              <scope
                :passport="passportByContactID(contact.contactID)"
                tag="el-row"
                :validateConfigs="validateConfigs"
              >
                <template v-if="passport" slot-scope="{ passport }">
                  <ae-error-wrapper
                    :is-error="validateConfigs[contact.contactID].passportImage"
                    error-message="Please upload a photo of your passport"
                    ref="ae-error-wrapper-field"
                  >
                    <template v-slot:form-item>
                      <el-upload
                        :action="uploadFileEndpoint"
                        :auto-upload="true"
                        :before-upload="beforeUpload"
                        :data="{
                          bookingID: booking.bookingID,
                          contactID: contact.contactID,
                          passportID: passport.passportID,
                        }"
                        :fileList="passport.file ? [passport.file] : undefined"
                        :headers="uploadFileHeaders"
                        :limit="1"
                        :multiple="false"
                        :on-error="onUploadError"
                        :on-remove="onRemoveUploadPassport"
                        :on-success="onSuccessUploadPassport"
                        accept="image/*,.pdf"
                        class="el-upload--passport"
                        list-type="picture"
                        name="passport"
                      >
                        <el-button size="small" type="primary"
                          >Upload a photo of your passport
                        </el-button>
                        <div slot="tip" class="el-upload__tip">
                          <PassportUploadPrompt />
                        </div>
                      </el-upload>
                    </template>
                  </ae-error-wrapper>
                </template>
              </scope>
            </section>

            <div class="residential-address-container">
              <div>
                <span>Residential address</span>
                <i>(optional)</i>
                <el-checkbox
                  v-if="contact.contactID !== primaryContact.contactID"
                  :value="contact.hasSameResidentialAddress"
                  class="checkbox--samePlan"
                  @input="
                    onCheckHasSameResidentialAddress(
                      contact.contactID,
                      'hasSameResidentialAddress',
                      $event,
                    )
                  "
                >
                  Same as Guest 1
                </el-checkbox>
              </div>
              <div class="residential-address-container__notes">
                Filling in your address will allow us to send you information
                about Aqua Expeditions' next destinations. Your data will be
                kept confidential.
              </div>
            </div>

            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item label="Address">
                  <el-input
                    :value="contact.mainMailingStreet"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'mainMailingStreet',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16" class="last-row">
              <el-col :span="6">
                <el-form-item label="Country">
                  <v-select
                    :clearable="false"
                    :filter-by="filterCountry"
                    :options="selectCountries"
                    :reduce="(item) => item.value"
                    :value="contact.mainMailingCountry"
                    filterable
                    label="label"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'mainMailingCountry',
                        $event,
                      )
                    "
                    @visible-change="resetFilterCountry"
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="City / Town">
                  <el-input
                    :value="contact.mainMailingCity"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'mainMailingCity',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="State / Province">
                  <v-select
                    :clearable="false"
                    :options="selectStates"
                    :reduce="(item) => item.value"
                    :value="contact.mainMailingState"
                    filterable
                    label="label"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'mainMailingState',
                        $event,
                      )
                    "
                  >
                  </v-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="Postal code">
                  <el-input
                    :value="contact.mainMailingZip"
                    @input="
                      onInputChange(contact.contactID, 'mainMailingZip', $event)
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <hr />

          <section
            v-if="
              booking.isFromVietnamToCambodia || booking.isFromCambodiaToVietnam
            "
          >
            <h3 style="margin-bottom: 24px">
              {{
                booking.isFromVietnamToCambodia
                  ? "Have you applied your cross-border visa?"
                  : "Please upload your cross-border visa."
              }}
            </h3>
            <el-alert
              :closable="false"
              show-icon
              style="margin-bottom: 14px"
              title="Important note:"
              type="warning"
            >
              <template v-if="booking.isFromVietnamToCambodia">
                <div>
                  We recommend that you apply the cross-border visa on board
                  with us. If you already have a physical visa, please upload a
                  copy here and bring along the physical copy. Online visas will
                  not be accepted.
                </div>
                <div>
                  <a
                    href=""
                    @click.prevent="isVisibleDialogVisaRequirement = true"
                    >More details</a
                  >
                </div>
              </template>
              <template v-else>
                <div>
                  Please read our instruction for Vietnam visa
                  <a
                    href=""
                    @click.prevent="isVisibleDialogVisaRequirement = true"
                    >here</a
                  >.
                </div>
              </template>
            </el-alert>

            <scope
              :visaRequirement="visaRequirementByContactID(contact.contactID)"
              tag="el-row"
              :validateConfigs="validateConfigs"
            >
              <template v-if="visaRequirement" slot-scope="{ visaRequirement }">
                <el-radio-group
                  :value="visaRequirement.visaType"
                  @input="
                    onVisaRequirementInputChange(
                      visaRequirement.visaRequirementID,
                      'visaType',
                      $event,
                      contact.contactID,
                    )
                  "
                >
                  <el-radio
                    v-if="booking.isFromVietnamToCambodia"
                    label="Apply Onboard"
                  >
                    <div>Apply on board</div>
                    <el-popover
                      content="Aqua Expeditions will process the Cambodia single entry tourist visa for you on-board. A US$45 fee will apply, paid in cash or charged to your account on the Aqua Mekong."
                      placement="top"
                      trigger="hover"
                      width="200"
                    >
                      <a slot="reference">Fee applies</a>
                    </el-popover>
                  </el-radio>
                  <el-radio
                    v-if="booking.isFromCambodiaToVietnam"
                    label="E Visa"
                  >
                    <div>I have an e-visa</div>
                  </el-radio>
                  <el-radio label="Physical Visa (Cross border)">
                    <div>
                      I have my
                      {{
                        booking.isFromVietnamToCambodia ? "Cambodia" : "Vietnam"
                      }}
                      Visa on my passport
                    </div>
                  </el-radio>
                  <el-radio label="Not required">
                    <span
                      >I do not need a visa to
                      {{
                        booking.isFromVietnamToCambodia ? "Cambodia" : "Vietnam"
                      }}</span
                    >
                  </el-radio>
                </el-radio-group>
                <ae-error-wrapper
                  :is-error="validateConfigs[contact.contactID].visaImage"
                  error-message="Please upload a photo of your visa"
                  ref="ae-error-wrapper-field"
                  v-if="visaRequirement.visaType === 'E Visa'"
                >
                  <template v-slot:form-item>
                    <el-upload
                      :action="uploadFileEndpoint"
                      :auto-upload="true"
                      :before-upload="beforeUpload"
                      :data="{
                        bookingID: booking.bookingID,
                        contactID: contact.contactID,
                        visaRequirementID: visaRequirement.visaRequirementID,
                      }"
                      :fileList="
                        visaRequirement.visaType === 'E Visa' &&
                        visaRequirement.file
                          ? [visaRequirement.file]
                          : undefined
                      "
                      :headers="uploadFileHeaders"
                      :limit="1"
                      :multiple="false"
                      :on-error="onUploadError"
                      :on-remove="onRemoveUploadVisa"
                      :on-success="onSuccessUploadVisa"
                      accept="image/*"
                      class="el-upload--visa"
                      list-type="picture"
                      name="visa"
                    >
                      <el-button size="small" type="primary"
                        >Upload a copy of your e-visa</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        jpg/png files with a size less than 1Mb
                      </div>
                    </el-upload>
                  </template>
                </ae-error-wrapper>
                <ae-error-wrapper
                  :is-error="validateConfigs[contact.contactID].visaImage"
                  error-message="Please upload a photo of your visa"
                  ref="ae-error-wrapper-field"
                  v-if="
                    visaRequirement.visaType === 'Physical Visa (Cross border)'
                  "
                >
                  <template v-slot:form-item>
                    <el-upload
                      :action="uploadFileEndpoint"
                      :auto-upload="true"
                      :before-upload="beforeUpload"
                      :data="{
                        bookingID: booking.bookingID,
                        contactID: contact.contactID,
                        visaRequirementID: visaRequirement.visaRequirementID,
                      }"
                      :fileList="
                        visaRequirement.visaType ===
                          'Physical Visa (Cross border)' && visaRequirement.file
                          ? [visaRequirement.file]
                          : undefined
                      "
                      :headers="uploadFileHeaders"
                      :limit="1"
                      :multiple="false"
                      :on-error="onUploadError"
                      :on-remove="onRemoveUploadVisa"
                      :on-success="onSuccessUploadVisa"
                      accept="image/*"
                      class="el-upload--visa"
                      list-type="picture"
                      name="visa"
                      style="margin-left: 200px"
                    >
                      <el-button size="small" type="primary"
                        >Upload a copy of your visa</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        jpg/png files with a size less than 1Mb
                      </div>
                    </el-upload>
                  </template>
                </ae-error-wrapper>
              </template>
            </scope>
          </section>

          <hr
            v-if="
              booking.isFromVietnamToCambodia || booking.isFromCambodiaToVietnam
            "
          />

          <section>
            <div class="form-subheader">
              Have you (or your client, if you're an agent) traveled with us
              before?
            </div>

            <el-checkbox
              :value="contact.hasPastGuest"
              @input="onInputChange(contact.contactID, 'hasPastGuest', $event)"
            >
              Yes, I have traveled with Aqua Expeditions before
            </el-checkbox>

            <div v-if="contact.hasPastGuest" style="margin-top: 24px">
              <el-row :gutter="16">
                <el-col :span="6">
                  <el-form-item
                    label="Previous cruise(s) with us"
                    prop="pastGuest"
                  >
                    <v-select
                      multiple
                      :clearable="false"
                      :options="selectLastDestinations"
                      :reduce="(item) => item.value"
                      :searchable="false"
                      :value="contact.pastGuest"
                      filterable
                      label="label"
                      @input="
                        onInputChange(contact.contactID, 'pastGuest', $event)
                      "
                    >
                    </v-select>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="8">-->
                <!--                  <el-form-item label="Last travel period (optional)">-->
                <!--                    &lt;!&ndash;<el-input :value="contact.pastTravelPeriodForAmazon" @input="onInputChange(contact.contactID, 'pastTravelPeriodForAmazon', $event)" />&ndash;&gt;-->
                <!--                    &lt;!&ndash;<el-input :value="contact.pastTravelPeriodForMekong" @input="onInputChange(contact.contactID, 'pastTravelPeriodForMekong', $event)" />&ndash;&gt;-->
                <!--                    <el-row :gutter="16">-->
                <!--                      <el-col :span="12">-->
                <!--                        <v-select v-model="modelPastTravelPeriodMonth[contact.contactID]"-->
                <!--                                  :clearable="false"-->
                <!--                                  :options="selectDateMonths"-->
                <!--                                  :reduce="item => item.value"-->
                <!--                                  filterable-->
                <!--                                  label="label"-->
                <!--                                  placeholder="Select month"-->
                <!--                                  @input="onInputPastTravelPeriodChange(contact.contactID, getPastTravelPeriodField(contact.pastGuest), $event)">-->
                <!--                        </v-select>-->
                <!--                      </el-col>-->

                <!--                      <el-col :span="12">-->
                <!--                        <v-select v-model="modelPastTravelPeriodYear[contact.contactID]"-->
                <!--                                  :clearable="false"-->
                <!--                                  :options="selectDateShipStartYears"-->
                <!--                                  :reduce="item => item.value"-->
                <!--                                  filterable-->
                <!--                                  label="label"-->
                <!--                                  placeholder="Select year"-->
                <!--                                  @input="onInputPastTravelPeriodChange(contact.contactID, getPastTravelPeriodField(contact.pastGuest), $event)">-->
                <!--                        </v-select>-->
                <!--                      </el-col>-->
                <!--                    </el-row>-->
                <!--                  </el-form-item>-->
                <!--                </el-col>-->
              </el-row>

              <div class="note">
                Note: To take advantage of
                <a :href="appendMarketingSiteUrl('/loyalty')" target="_blank"
                  >our loyalty benefits</a
                >, please
                <a :href="appendMarketingSiteUrl('/contact-us')" target="_blank"
                  >contact</a
                >
                our Sales and Reservation team.
              </div>
            </div>
          </section>

          <hr />

          <section>
            <div class="form-subheader">
              Emergency contact
              <el-checkbox
                v-if="contact.contactID !== primaryContact.contactID"
                :value="contact.hasSameEmergencyContact"
                class="checkbox--samePlan"
                @input="
                  onCheckHasSameEmergencyContact(
                    contact.contactID,
                    'hasSameEmergencyContact',
                    $event,
                  )
                "
              >
                Same as Guest 1
              </el-checkbox>
            </div>

            <el-row :gutter="16">
              <el-col :span="6">
                <el-form-item
                  label="First name"
                  prop="emergencyContactFirstName"
                >
                  <el-input
                    :value="contact.emergencyContactFirstName"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'emergencyContactFirstName',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
              <!--<el-col :span="4">-->
              <!--<el-form-item label="Middle name">-->
              <!--<el-input :value="contact.emergencyContactMiddleName"-->
              <!--@input="onInputChange(contact.contactID, 'emergencyContactMiddleName', $event)"/>-->
              <!--</el-form-item>-->
              <!--</el-col>-->
              <el-col :span="6">
                <el-form-item
                  label="Last / Family name"
                  prop="emergencyContactLastName"
                >
                  <el-input
                    :value="contact.emergencyContactLastName"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'emergencyContactLastName',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="Contact number"
                  prop="emergencyContactPhone"
                >
                  <el-input
                    :value="contact.emergencyContactPhone"
                    placeholder="eg: +1-234-457-8900"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'emergencyContactPhone',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item
                  label="Relationship"
                  prop="emergencyContactRelation"
                >
                  <v-select
                    :ref="'emergencyRelationSelect' + contact.contactID"
                    :clearable="false"
                    :options="selectEmergencyContactRelations"
                    :reduce="(item) => item.value"
                    :searchable="false"
                    :value="contact.emergencyContactRelation"
                    class="v-select-overflow"
                    filterable
                    label="label"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'emergencyContactRelation',
                        $event,
                      )
                    "
                    v-on:search:focus="
                      onEmergencyRelationFocus(contact.contactID)
                    "
                  >
                  </v-select>
                  <!--<el-select filterable-->
                  <!--:value="contact.emergencyContactRelation"-->
                  <!--@input="onInputChange(contact.contactID, 'emergencyContactRelation', $event)"-->
                  <!--&gt;-->
                  <!--<el-option v-for="emergencyContactRelations in selectEmergencyContactRelations"-->
                  <!--:key="emergencyContactRelations.value"-->
                  <!--:label="emergencyContactRelations.label"-->
                  <!--:value="emergencyContactRelations.value" />-->
                  <!--</el-select>-->
                  <!--<select filterable-->
                  <!--placement="top"-->
                  <!--:value="contact.emergencyContactRelation"-->
                  <!--@input="onInputChange(contact.contactID, 'emergencyContactRelation', $event)">-->
                  <!--<option v-for="emergencyContactRelation in selectEmergencyContactRelations"-->
                  <!--:key="emergencyContactRelation.value"-->
                  <!--:label="emergencyContactRelation.label"-->
                  <!--:value="emergencyContactRelation.value"/>-->
                  <!--</select>-->
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Email" prop="emergencyContactEmail">
                  <el-input
                    :value="contact.emergencyContactEmail"
                    placeholder="Enter email address"
                    @input="
                      onInputChange(
                        contact.contactID,
                        'emergencyContactEmail',
                        $event,
                      )
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section v-if="!isAquaNeraOrAriaAmazon()">
            <hr />

            <div class="form-subheader">
              Release of Liability and Assumption of Risk
            </div>
            <el-form-item
              label="Release of Liability"
              prop="HasSignedReleaseOfLiability"
            >
              <el-checkbox
                :value="contact.HasSignedReleaseOfLiability"
                @input="
                  onInputChange(
                    contact.contactID,
                    'HasSignedReleaseOfLiability',
                    $event,
                  )
                "
              >
                I understand and agree to the terms of the
                <span class="rol-link" @click="handleClickROL"
                  >Release of Liability and Assumption of Risk</span
                >.
              </el-checkbox>
            </el-form-item>
          </section>

          <section v-if="isAquaNeraOrAriaAmazon()">
            <hr />

            <div class="form-subheader">
              Release of Liability and Assumption of Risk
            </div>
            <el-form-item
              label="Release of Liability"
              prop="HasSignedReleaseOfLiability"
            >
              <el-checkbox
                :value="contact.HasSignedReleaseOfLiability"
                @input="
                  onInputChange(
                    contact.contactID,
                    'HasSignedReleaseOfLiability',
                    $event,
                  )
                "
              >
                I understand and agree to the terms of the
                <span class="rol-link" @click="handleClickROL"
                  >Release of Liability and Assumption of Risk (English)</span
                >
                /
                <span class="rol-link" @click="handleClickROLSpanish"
                  >Release of Liability and Assumption of Risk (Spanish)</span
                >.
              </el-checkbox>
            </el-form-item>
          </section>

          <!--<el-row type="flex" justify="end">-->
          <!--<el-button type="text" :loading="saveContactLoadings[contact.contactID]" @click="onClickSave('formValidate', contact, index)">Save-->
          <!--</el-button>-->
          <!--</el-row>-->
        </el-form>
      </el-collapse-item>
    </el-collapse>

    <div class="sticky-bottom">
      <el-row class="bottom-nav" justify="space-between" type="flex">
        <el-button
          class="button--secondary"
          :disabled="isSaving"
          type="secondary"
          @click="onClickBack"
          >Back</el-button
        >

        <autosave-indicator />
        <el-button
          :disabled="isSaving"
          class="button--tertiary"
          type="secondary"
          @click="onClickSaveAndExit(false)"
          >Save
        </el-button>
        <el-button
          class="button--primary"
          :disabled="isSaving"
          type="primary"
          @click="onClickNext"
          >Next</el-button
        >
      </el-row>
    </div>

    <el-dialog
      :visible="this.isVisibleDialogVisaRequirement"
      class="dialog--visaRequirement"
      show-close
      @close="isVisibleDialogVisaRequirement = false"
    >
      <div v-if="booking.isFromCambodiaToVietnam">
        <h2>Visa for cruising from CAMBODIA to VIETNAM</h2>

        <div class="visa-tag">Vietnam Visa</div>

        <p class="no-break-words">
          Please check if your country is exempted of entry to Vietnam
          <a
            href="https://lanhsuvietnam.gov.vn/Lists/BaiViet/B%C3%A0i%20vi%E1%BA%BFt/DispForm.aspx?List=dc7c7d75-6a32-4215-afeb-47d4bee70eee&ID=306"
            target="_blank"
            >here</a
          >.
        </p>

        <p class="no-break-words" style="margin-bottom: 24px">
          If you need a visa, please check the following options:
        </p>

        <div class="option">
          <div class="title">OPTION 1 – E-Visa (Recommended)</div>
          <p class="no-break-words">
            Apply for E-Visa
            <a href="https://evisa.gov.vn/" target="_blank">here</a>, with the
            <span class="text--strong">same passport</span> you will be using
            for entry into Vietnam.
          </p>
          <ul class="visa-bullets">
            <li>
              E-Visa will be processed after the Vietnam Immigration Department
              receives the completed application and full e-Visa fee.
            </li>
            <li>
              Ensure that you enter the correct
              <span class="text--strong">date of entry</span> into Vietnam as
              per your itinerary. The border crossing always occurs on a
              Wednesday. Please note that this is
              <span class="text--strong">not</span> the same as your day of
              embarkation on Aqua Mekong.
            </li>
            <li>
              <span class="text--warning"
                >Please send us a copy of your e-visa confirmation</span
              >
              and present a printed copy together with your passport upon
              embarkation of the Aqua Mekong.
            </li>
          </ul>
          <p class="no-break-words" style="margin-top: 16px">
            <span class="text--strong">Notes: </span>please list
            <span class="text--strong"
              >Vinh Xuong Landport, An Giang Province</span
            >
            as your port of entry.
          </p>
          <p class="no-break-words" style="margin-top: 16px">
            <span class="text--strong"
              >E-Visa Processing Time for Vietnam:</span
            >
          </p>
          <p class="no-break-words">
            Please note that the e-visa process may take 3–5 working days to
            complete. We recommend applying as early as possible to avoid
            delays.
          </p>
          <p class="no-break-words" style="margin-top: 16px">
            <span class="text--strong">Uploading Your E-Visa:</span>
          </p>
          <p class="no-break-words">
            Once you receive your e-visa, please upload it directly to the
            check-in platform. Alternatively, you may email it to
            <a href="mailto:reservations@aquaexpeditions.com"
              >reservations@aquaexpeditions.com</a
            >, and we’ll upload it on your behalf.
          </p>
        </div>

        <div class="option">
          <div class="title">OPTION 2 – Physical Visa from Embassy</div>
          <p class="no-break-words">
            Obtain Visa at the Vietnam embassy in your home country.
            <span class="text--strong">Physical visa</span> must be in your
            passport prior to boarding the Aqua Mekong.
            <span class="text--warning"
              >Please upload a copy of this Visa.</span
            >
          </p>
        </div>

        <div class="note--important no-break-words">
          <i class="el-icon-warning"></i><b>IMPORTANT</b>: Please ensure you are
          using the <u>same passport</u> to enter Vietnam and Cambodia, if you
          are cruising between both countries with the Aqua Mekong. Otherwise,
          the port authority may deny your entry during river border crossing,
          thus affecting your trip. Travelers must submit the Cambodia e-Arrival
          <u><b>within 7 days</b></u> before their arrival
          <a href="https://arrival.gov.kh/" target="_blank">here</a>.
        </div>

        <!--<p style="margin-bottom: 24px;">You <span class="text&#45;&#45;strong">must obtain</span> your visa at the Vietnam embassy of your home country. <span class="text&#45;&#45;strong">Physical visa</span> must be in your passport prior to boarding the Aqua Mekong. <span class="text&#45;&#45;warning">Please upload a copy of this visa.</span></p>-->

        <!--<div class="note&#45;&#45;important"><i class="el-icon-warning"></i>Important note: E-visa and visa on arrival is NOT valid for crossing border via waterways.</div>-->

        <hr />

        <div class="visa-tag">Cambodia Visa</div>
        <p class="no-break-words" style="margin-bottom: 24px">
          We <span class="text--strong">do not require</span> you to upload your
          Cambodia visa, however please ensure you hold a valid Cambodia visa,
          if required.
        </p>

        <div class="option">
          <div class="title">OPTION 1 (Recommended)</div>
          <p class="no-break-words">
            Apply for E-visa at
            <a href="https://www.evisa.gov.kh" target="_blank"
              >www.evisa.gov.kh</a
            >, a <span class="text--strong">printed copy</span> of your e-visa
            must be presented at the airport upon arrival.
          </p>
        </div>

        <div class="option">
          <div class="title">OPTION 2</div>
          <p class="no-break-words">
            Apply for Visa <span class="text--strong">on arrival</span> at Phnom
            Penh or Siem Reap airport at
            <span class="text--strong">USD $30</span> in cash. Please bring
            along a passport size photograph. If you do not bring your
            photograph, the extra charge is USD $3.
          </p>
        </div>

        <div class="option">
          <div class="title">OPTION 3</div>
          <p class="no-break-words">
            Obtain visa at the Cambodia embassy in your home country.
          </p>
        </div>
      </div>
      <div v-else-if="booking.isFromVietnamToCambodia">
        <h2>Visa for cruising from VIETNAM to CAMBODIA</h2>

        <div class="visa-tag">Cambodia Visa</div>

        <div class="option">
          <div class="title">OPTION 1 - Apply on board</div>
          <p class="no-break-words">
            Aqua Expeditions will process the Cambodia single entry tourist visa
            for you on-board. A US$45 fee (exclusive of VAT) will apply, paid in
            cash or charged to your account on the Aqua Mekong.
          </p>
        </div>

        <div class="option">
          <div class="title">OPTION 2 - Apply via embassy</div>
          <p class="no-break-words">
            Obtain visa at a Cambodia embassy of your home country. Physical
            visa must be placed inside your passport prior to boarding the Aqua
            Mekong.
            <span class="text--warning"
              >Please upload a copy of this visa.</span
            >
          </p>
        </div>

        <div class="note--important no-break-words">
          <i class="el-icon-warning"></i>Note: E-visa is not valid for crossing
          border via waterways.
        </div>

        <div class="note--important no-break-words">
          <i class="el-icon-warning"></i><b>IMPORTANT</b>: Please ensure you are
          using the <u>same passport</u> to enter Vietnam and Cambodia, if you
          are cruising between both countries with the Aqua Mekong. Otherwise,
          the port authority may deny your entry during river border crossing,
          thus affecting your trip.
        </div>

        <hr />

        <div class="visa-tag">Vietnam Visa</div>
        <p class="no-break-words" style="margin-bottom: 24px">
          We <span class="text--strong">do not require</span> you to upload your
          Vietnam visa, however please ensure you hold a valid Vietnam visa, if
          required.
        </p>

        <p class="no-break-words">
          Please check if your country is exempted of entry to Vietnam
          <a
            href="https://lanhsuvietnam.gov.vn/Lists/BaiViet/B%C3%A0i%20vi%E1%BA%BFt/DispForm.aspx?List=dc7c7d75-6a32-4215-afeb-47d4bee70eee&ID=306"
            target="_blank"
            >here</a
          >.
        </p>

        <p class="no-break-words" style="margin-bottom: 24px">
          If you need a visa, please check the following options:
        </p>

        <div class="option">
          <div class="title">OPTION 1 – E-Visa (Recommended)</div>
          <!--<p>Apply for the visa pre-approval letter at <a href="https://www.vietnamvisacorp.com" target="_blank">www.vietnamvisacorp.com</a> which will be sent to your email after 2 working days.-->
          <!--When you arrive at your first airport of entry into Vietnam, proceed to the visa counter to obtain your visa.-->
          <!--<span class="text&#45;&#45;strong">Printed pre-approval letter</span> must be presented, together with a passport photo and <span class="text&#45;&#45;strong">US$45 cash</span> for single entry visa.-->
          <!--</p>-->

          <p class="no-break-words">
            Apply for E-Visa
            <a
              href="https://evisa.xuatnhapcanh.gov.vn/en_US/web/guest/khai-thi-thuc-dien-tu/cap-thi-thuc-dien-tu"
              target="_blank"
              >here</a
            >.
          </p>
          <p class="no-break-words">
            1. E-Visa will be processed after the Vietnam Immigration Department
            receives the completed application and full e-Visa fee.
          </p>
          <p class="no-break-words">
            2. E-Visa holders must present the printed e-Visa and valid passport
            at the checkpoint.
          </p>
        </div>

        <div class="option">
          <div class="title">OPTION 2 – Physical Visa from Embassy</div>
          <p class="no-break-words">
            Obtain Visa at the Vietnam embassy in your home country.
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import types from "../store/types";
import { HTTP } from "../api/http-common";
import { delay, padTime, positionDropdown, waitUntil } from "../utils";
import iconPdf from "../assets/images/icon-pdf.png";

import {
  ACCEPTED_UPLOAD_MIMETYPES,
  ACCEPTED_UPLOAD_MIMETYPES_PASSPORT,
  COUNTRIES,
  DATE_DAYS,
  DATE_EXPIRY_YEARS,
  DATE_MONTHS,
  DATE_SHIP_START_YEARS,
  DATE_YEARS,
  EMERGENCY_CONTACT_RELATIONS,
  FACILITY_CODES,
  GENDERS,
  LAST_DESTINATIONS,
  STATES,
  TITLES,
  UNHANDLED_ERROR_MESSAGE,
  VISA_TYPE_REQUIRING_ATTACHMENTS,
} from "../constants";
import contactMixin from "../mixins/contact";
import autosave from "../mixins/autosave";
import ProgressBar from "./ProgressBar";
import AutosaveIndicator from "./AutosaveIndicator";
import { timeTrack } from "../mixins/timeTrack";
import PassportUploadPrompt from "./PassportUploadPrompt.vue";
import AeErrorWrapper from "./AeErrorWrapper.vue";

// Fields whose changes must run through Zoho/Resco once the user finishes typing
const WORKFLOW_TRIGGER_FIELDS = [
  "mainMailingCountry",
  "email",
  "firstName",
  "lastName",
  "phone",
  "dateOfBirth",
];
const WORKFLOW_TRIGGER_AUTOSAVE_DELAY = 15000; // allow extra time for new value before the workflow fires
const WORKFLOW_TRIGGER_AUTOSAVE_GAP = 45000; // prevent another autosave while Zoho/Resco sync is still running

export default {
  props: {
    index: Number,
  },
  mixins: [contactMixin, timeTrack, autosave],
  components: {
    ProgressBar,
    AutosaveIndicator,
    PassportUploadPrompt,
    AeErrorWrapper,
  },
  mounted() {
    this.initializeAutosave(
      this.onClickSaveAndExit.bind(this),
      this.$refs.formRoot,
    );
  },
  created() {
    this.getDietaryAllergiesData();
    gtag("set", "page_path", "/step-2");
    gtag("event", "page_path", {
      path: "/step-2",
    });
  },
  data() {
    const contacts = this.$store.getters["contacts"];
    const booking = this.$store.getters["booking"];

    var validateReleaseOfLiability = (rule, value, callback) => {
      if (value !== true) {
        callback(
          new Error(
            "Please ensure that the release of liability checkbox is filled",
          ),
        );
      } else {
        callback();
      }
    };

    const validatePastGuest = (rule, value, callback) => {
      if ((Array.isArray(value) && value.length === 0) || !value) {
        callback(new Error("This field is required"));
      } else {
        callback();
      }
    };

    const validationConfig = (message, trigger) => ({
      required: true,
      message: message || "Required",
      trigger: trigger || "change blur",
    });
    const ruleValidate = {
      title: [validationConfig()],
      firstName: [validationConfig("Please enter your first name.")],
      lastName: [validationConfig("Please enter your last/family name.")],
      dateOfBirth: [validationConfig("Please provide your date of birth")],
      email: [
        {
          type: "email",
          message: "Please input correct email address",
          trigger: ["blur", "change", "input"],
        },
      ],
      mainMailingCountry: [validationConfig()],
      nationality: [validationConfig("Please enter your nationality.")],
      gender: [
        validationConfig("Please indicate your gender (e.g. Male, Female)."),
      ],
      passportNumber: [validationConfig("Please enter your passport number.")],
      passportIssuingCountry: [
        validationConfig(
          "Please specify the country that issued your passport.",
        ),
      ],
      nationalIdNumber: [validationConfig()],
      passportExpiryDate: [
        validationConfig("Please enter the date your passport will expire "),
      ],
      emergencyContactFirstName: [validationConfig()],
      emergencyContactLastName: [validationConfig()],
      emergencyContactPhone: [validationConfig()],
      emergencyContactRelation: [validationConfig()],
      pastGuest: [
        {
          validator: validatePastGuest,
          trigger: "change blur",
        },
      ],
      HasSignedReleaseOfLiability: [
        {
          validator: validateReleaseOfLiability,
          trigger: "change blur",
        },
      ],
    };

    if (!booking.isAmazonCruise) {
      ruleValidate.passportIssueDate = [validationConfig()];
    }

    // Quick fix workaround to apply validation for passport field
    // TODO: Revamp validation approach for all steps.
    let validateModel = {
      passportImage: false,
      visaImage: false,
    };

    let validateConfigs = {};
    contacts.forEach((contact) => {
      validateConfigs[contact.contactID] = structuredClone(validateModel);
    });

    return {
      fileType: "picture",
      iconPdf: iconPdf,
      activeCollapseIndexes: this.index
        ? [this.index]
        : contacts.map((contact, index) => index),
      uploadFileEndpoint: `${HTTP.defaults.baseURL}/upload`,
      uploadFileHeaders: {
        Authorization: this.$store.getters["accessToken"],
      },
      isVisibleDialogVisaRequirement: false,
      nextSaveRequiresWorkflowTrigger: false, // flags autosave to trigger Zoho workflow for specific field changes
      selectCountries: COUNTRIES,
      selectStates: STATES,
      selectGenders: GENDERS,
      selectTitles: TITLES,
      selectLastDestinations: LAST_DESTINATIONS,
      selectEmergencyContactRelations: EMERGENCY_CONTACT_RELATIONS,
      selectDateDays: DATE_DAYS,
      selectDateMonths: DATE_MONTHS,
      selectDateYears: DATE_YEARS,
      selectDateExpiryYears: DATE_EXPIRY_YEARS,
      selectDateShipStartYears: DATE_SHIP_START_YEARS,
      ruleValidate,
      validateConfigs,
      saveContactLoadings: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = false;
        return accumulator;
      }, {}),
      modelDateOfBirthDays: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.dateOfBirth
          ? current.dateOfBirth.split("-")[2]
          : "";
        return accumulator;
      }, {}),
      modelDateOfBirthMonths: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.dateOfBirth
          ? current.dateOfBirth.split("-")[1]
          : "";
        return accumulator;
      }, {}),
      modelDateOfBirthYears: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.dateOfBirth
          ? current.dateOfBirth.split("-")[0]
          : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateDays: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportExpiryDate
          ? current.passportExpiryDate.split("-")[2]
          : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateMonths: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportExpiryDate
          ? current.passportExpiryDate.split("-")[1]
          : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateYears: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportExpiryDate
          ? current.passportExpiryDate.split("-")[0]
          : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateDays: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportIssueDate
          ? current.passportIssueDate.split("-")[2]
          : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateMonths: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportIssueDate
          ? current.passportIssueDate.split("-")[1]
          : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateYears: contacts.reduce((accumulator, current) => {
        accumulator[current.contactID] = current.passportIssueDate
          ? current.passportIssueDate.split("-")[0]
          : "";
        return accumulator;
      }, {}),
      modelPastTravelPeriodMonth: contacts.reduce((accumulator, current) => {
        const fieldName = this.getPastTravelPeriodField(current.pastGuest);
        accumulator[current.contactID] = current[fieldName]
          ? current[fieldName].split(" ")[0]
          : "";
        return accumulator;
      }, {}),
      modelPastTravelPeriodYear: contacts.reduce((accumulator, current) => {
        const fieldName = this.getPastTravelPeriodField(current.pastGuest);
        accumulator[current.contactID] = current[fieldName]
          ? current[fieldName].split(" ")[1]
          : "";
        return accumulator;
      }, {}),
    };
  },
  computed: {
    ...mapGetters([
      types.getters.booking,
      types.getters.contacts,
      types.getters.contact,
      types.getters.visaRequirements,
      types.getters.visaRequirement,
      types.getters.visaRequirementByContactID,
      types.getters.passports,
      types.getters.passport,
      types.getters.passportByContactID,
      types.getters.primaryContact,
      types.getters.isSaving,
      types.getters.dietaryAllergies,
    ]),
    getProgressedPercentage: function () {
      return function (contact) {
        const mandatoryFields = this.getContactMandatoryFields();
        const completedFields = mandatoryFields.filter(
          (field) => contact[field],
        );
        const visaRequirement = this.visaRequirementByContactID(
          contact.contactID,
        );
        const passport = this.passportByContactID(contact.contactID);

        let numMandatoryFields = mandatoryFields.length;
        let numCompletedFields = completedFields.length;

        if (contact.hasPastGuest) {
          numMandatoryFields++;
          numCompletedFields += contact.pastGuest ? 1 : 0;
        }

        if (
          visaRequirement &&
          VISA_TYPE_REQUIRING_ATTACHMENTS.indexOf(visaRequirement.visaType) >= 0
        ) {
          numMandatoryFields++;

          if (
            visaRequirement._relativePath ||
            (visaRequirement.attachmentID &&
              !visaRequirement._removeUploadedVisa)
          ) {
            numCompletedFields++;
          }
        }

        // Add passport image
        if (passport) {
          numMandatoryFields++;
          console.log("passport: ", passport);
          if (passport.file && passport.file.name.includes(".pdf")) {
            passport.file.url = iconPdf;
          }
          if (
            passport._relativePath ||
            (passport.attachmentID && passport._removeUploadedPassport)
          ) {
            numCompletedFields++;
          }
        }

        return Math.round((numCompletedFields / numMandatoryFields) * 100);
      };
    },
    formElements() {
      const forms = Object.keys(this.$refs).filter((key) =>
        key.startsWith("formValidate"),
      );
      let results = [];
      for (const formKey of forms) {
        results.push(this.$refs[formKey][0]);
      }
      return results;
    },
  },
  methods: {
    ...mapActions([
      types.actions.updateContactField,
      types.actions.updateVisaRequirementField,
      types.actions.updatePassportField,
      types.actions.updateContactsAndVisaRequirementsRemote,
      types.actions.setIsVisibleDialogSaveAndExit,
      types.actions.setIsSaving,
      types.actions.getDietaryAllergies,
    ]),
    async getDietaryAllergiesData() {
      try {
        await this.getDietaryAllergies();
      } catch (error) {
        console.error("Unable to retrieve dietary allergies from API:", error);
      }
    },
    appendMarketingSiteUrl(path) {
      return `${process.env.MARKETING_SITE_FRONTEND_URL}${path || ""}`;
    },
    filterCountry(option, country, query) {
      const index = country.toLowerCase().indexOf(query.toLowerCase());
      if (index === -1) {
        return false;
      }

      if (index === 0) {
        return true;
      }

      const prevChar = country.toLowerCase()[index - 1];
      return prevChar === " ";
    },
    resetFilterCountry(showHide) {
      this.selectCountries = COUNTRIES;
    },
    canShowPeruvianNationalIDField(contact) {
      return (
        this.booking.isAmazonCruise &&
        contact.nationality === "PE - Peru" &&
        contact.mainMailingCountry === "PE - Peru"
      );
    },
    async onInputDateChange(contactID, fieldName, event, contactFieldName) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      let value = "";

      switch (contactFieldName) {
        case "dateOfBirth":
          value =
            this.modelDateOfBirthDays[contactID] &&
            this.modelDateOfBirthMonths[contactID] &&
            this.modelDateOfBirthYears[contactID]
              ? `${this.modelDateOfBirthYears[contactID]}-${padTime(this.modelDateOfBirthMonths[contactID])}-${padTime(this.modelDateOfBirthDays[contactID])}`
              : "";
          break;
        case "passportExpiryDate":
          value =
            this.modelPassportExpiryDateYears[contactID] &&
            this.modelPassportExpiryDateMonths[contactID] &&
            this.modelPassportExpiryDateDays[contactID]
              ? `${this.modelPassportExpiryDateYears[contactID]}-${padTime(this.modelPassportExpiryDateMonths[contactID])}-${padTime(this.modelPassportExpiryDateDays[contactID])}`
              : "";
          break;
        case "passportIssueDate":
          value =
            this.modelPassportIssueDateYears[contactID] &&
            this.modelPassportIssueDateMonths[contactID] &&
            this.modelPassportIssueDateDays[contactID]
              ? `${this.modelPassportIssueDateYears[contactID]}-${padTime(this.modelPassportIssueDateMonths[contactID])}-${padTime(this.modelPassportIssueDateDays[contactID])}`
              : "";
          break;
        default:
          console.warn("Invalid contactFieldName:", contactFieldName);
          return;
      }
      await waitUntil(() => !this.isSaving);
      if (contactFieldName === "dateOfBirth") {
        this.nextSaveRequiresWorkflowTrigger = true; // birthdate adjustments should immediately flow to Zoho/Resco
        this.autosaveIdleDelay = Math.max(
          this.autosaveIdleDelay,
          WORKFLOW_TRIGGER_AUTOSAVE_DELAY,
        );
        this.minAutosaveGap = Math.max(
          this.minAutosaveGap,
          WORKFLOW_TRIGGER_AUTOSAVE_GAP,
        );
        this.scheduleAutosave(this.autosaveIdleDelay); // extend autosave window for workflow-triggering fields
      }
      this[types.actions.updateContactField]({
        contactID,
        fieldName: contactFieldName,
        value,
      });
    },
    async onVisaRequirementInputChange(
      visaRequirementID,
      fieldName,
      event,
      contactID,
    ) {
      console.log(
        "[visaRequirementID, fieldName, event, contactID]",
        visaRequirementID,
        fieldName,
        event,
        contactID,
      );
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateVisaRequirementField]({
        visaRequirementID,
        fieldName,
        value: event,
      });

      if (fieldName === "visaType") {
        if (event === "Apply Onboard") {
          // Set default payment status to 'Charge on board' if visaType is 'Apply Onboard' and payment status is empty
          const visaRequirement = this.visaRequirement(visaRequirementID);
          if (visaRequirement && !visaRequirement.paymentStatus) {
            this[types.actions.updateVisaRequirementField]({
              visaRequirementID,
              fieldName: "paymentStatus",
              value: "Charge on board",
            });
          }
        } else {
          // paymentStatus is not applicable if visaType is not 'Apply Onboard', so set it to empty here
          this[types.actions.updateVisaRequirementField]({
            visaRequirementID,
            fieldName: "paymentStatus",
            value: "",
          });
        }
      }
    },
    async onInputPastTravelPeriodChange(contactID, fieldName, event) {
      console.log(
        "[contactID, fieldName, event]:",
        contactID,
        fieldName,
        event,
      );
      await waitUntil(() => !this.isSaving);
      const value = [
        this.modelPastTravelPeriodMonth[contactID],
        this.modelPastTravelPeriodYear[contactID],
      ].join(" ");
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });
    },
    async onEmergencyRelationFocus(contactID) {
      const select = this.$refs[`emergencyRelationSelect${contactID}`][0];
      await delay(1);
      const dropdown =
        select.$el.querySelector(".vs__dropdown-menu") ||
        document.querySelector(
          "body > .vs__dropdown-menu:not(.vs__fade-leave-active)",
        );
      // console.log('onEmergencyRelationFocus focused', select, dropdown);
      if (!dropdown) {
        return;
      }
      positionDropdown(select.$el, dropdown);
      dropdown.style.width = "inherit";
    },
    async onInputChange(contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value: event,
      });
      if (WORKFLOW_TRIGGER_FIELDS.indexOf(fieldName) > -1) {
        this.nextSaveRequiresWorkflowTrigger = true; // ensure key personal details reach downstream systems immediately
        this.autosaveIdleDelay = Math.max(
          this.autosaveIdleDelay,
          WORKFLOW_TRIGGER_AUTOSAVE_DELAY,
        );
        this.minAutosaveGap = Math.max(
          this.minAutosaveGap,
          WORKFLOW_TRIGGER_AUTOSAVE_GAP,
        );
        this.scheduleAutosave(this.autosaveIdleDelay); // push autosave window so user can finish editing before workflow fires
      }
      const contact = this.contact(contactID);

      // If user selects 'No' for 'Have you traveled with us before',
      // need to reset the value for pastGuest, pastTravelPeriodForAmazon and pastTravelPeriodForMekong
      if (fieldName === "hasPastGuest" && !event) {
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "pastGuest",
          value: "",
        });
        // Reset each pastTravelPeriod[*] field for each destination
        Object.keys(types.fields.pastTravelPeriod).forEach((destination) => {
          this[types.actions.updateContactField]({
            contactID,
            fieldName: types.fields.pastTravelPeriod[destination],
            value: "",
          });
        });
        this.modelPastTravelPeriodMonth[contactID] = "";
        this.modelPastTravelPeriodYear[contactID] = "";
      }

      // If user changes 'pastGuest' (e.g. from 'Amazon' to 'Mekong' or vice versa)
      // clear the value for all past travel period fields (pastTravelPeriodForMekong and pastTravelPeriodForAmazon)
      else if (fieldName === "pastGuest") {
        // Reset each pastTravelPeriod[*] field for each destination
        Object.keys(types.fields.pastTravelPeriod).forEach((destination) => {
          this[types.actions.updateContactField]({
            contactID,
            fieldName: types.fields.pastTravelPeriod[destination],
            value: "",
          });
        });
        this.modelPastTravelPeriodMonth[contactID] = "";
        this.modelPastTravelPeriodYear[contactID] = "";
      }

      // Handle remove "Same as Guest 1" check for emergency contact fields
      // If the emergency contact field of primary contact is changed, uncheck hasSameEmergencyContact for all other contacts.
      // If the emergency contact field of non-primary contact is changed, uncheck hasSameEmergencyContact for the particular contact.
      const emergencyContactFields = [
        "emergencyContactFirstName",
        "emergencyContactMiddleName",
        "emergencyContactLastName",
        "emergencyContactPhone",
        "emergencyContactRelation",
        "emergencyContactEmail",
      ];

      if (emergencyContactFields.indexOf(fieldName) > -1) {
        if (contact.isPrimaryContact) {
          const contactsToUpdate = this.contacts.filter(
            (contact) =>
              !contact.isPrimaryContact && contact.hasSameEmergencyContact,
          );
          contactsToUpdate.forEach((contact) => {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSameEmergencyContact",
              value: false,
            });
          });
        } else {
          if (contact.hasSameEmergencyContact) {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSameEmergencyContact",
              value: false,
            });
          }
        }
      }

      // Handle remove "Same as Guest 1" check for residential address fields
      // If the residential address field of primary contact is changed, uncheck hasSameResidentialAddress for all other contacts.
      // If the residential address field of non-primary contact is changed, uncheck hasSameResidentialAddress for the particular contact.
      const residentialAddressFields = [
        "mainMailingStreet",
        "mainMailingCountry",
        "mainMailingCity",
        "mainMailingState",
        "mainMailingZip",
      ];

      if (residentialAddressFields.indexOf(fieldName) > -1) {
        if (contact.isPrimaryContact) {
          const contactsToUpdate = this.contacts.filter(
            (contact) =>
              !contact.isPrimaryContact && contact.hasSameResidentialAddress,
          );
          contactsToUpdate.forEach((contact) => {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSameResidentialAddress",
              value: false,
            });
          });
        } else {
          if (contact.hasSameResidentialAddress) {
            this[types.actions.updateContactField]({
              contactID: contact.contactID,
              fieldName: "hasSameResidentialAddress",
              value: false,
            });
          }
        }
      }
      await this.validateIndividualFields(contactID, fieldName); //Validate after input change
    },
    beforeUpload(file) {
      console.log("uploadfile: ", file);
      if (
        file.type &&
        ACCEPTED_UPLOAD_MIMETYPES_PASSPORT.indexOf(file.type) < 0
      ) {
        this.$message.error("Please upload a jpg/png/pdf file!");
        return false;
      }
      this[types.actions.setIsSaving]({ isSaving: true });
      this.fileType = file.type;
    },
    onUploadError() {
      this[types.actions.setIsSaving]({ isSaving: false });
    },
    async onSuccessUploadVisa(response, file, fileList) {
      // console.log("[onSuccessUploadVisa]:", response, file, fileList);
      const { bookingID, contactID, visaRequirementID, relativePath } =
        response;
      // console.log("bookingID, contactID, visaRequirementID, relativePath:", bookingID, contactID, visaRequirementID, relativePath);
      // console.log("file:", file);
      this[types.actions.setIsSaving]({ isSaving: false });
      await waitUntil(() => !this.isSaving);
      // uploadVisaUID is an identifier to inform server to update new visa
      // and to allow onRemoveUploadVisa to identify which visaRequirement
      this[types.actions.updateVisaRequirementField]({
        visaRequirementID,
        fieldName: "_uploadVisaUID",
        value: file.uid,
      });

      this[types.actions.updateVisaRequirementField]({
        visaRequirementID,
        fieldName: "_relativePath",
        value: relativePath,
      });
    },
    async onRemoveUploadVisa(file, fileList) {
      console.log("[onRemoveUploadVisa]:", file, fileList);
      await waitUntil(() => !this.isSaving);
      let visaRequirement = file.visaRequirementID
        ? // If the file is pre-populated from server, we can retrieve the visaRequirementID directly
          this.visaRequirement(file.visaRequirementID)
        : // If the file is uploaded by user, we can find the matching visaRequirement by file.uid
          this.visaRequirements.find(
            (visaRequirement) => visaRequirement._uploadVisaUID === file.uid,
          );

      if (!visaRequirement) {
        console.log("error: Cannot find visaRequirementID");
        return;
      }

      const { visaRequirementID } = visaRequirement;

      this[types.actions.updateVisaRequirementField]({
        visaRequirementID,
        fieldName: "_uploadVisaUID",
        value: undefined,
      });

      this[types.actions.updateVisaRequirementField]({
        visaRequirementID,
        fieldName: "_relativePath",
        value: undefined,
      });

      // removeUploadedVisa is a flag to indicate server to remove existing visa
      // Set it to true if there is existing file on the server (ie. visaRequirement.file is truthy)
      if (visaRequirement.file) {
        this[types.actions.updateVisaRequirementField]({
          visaRequirementID,
          fieldName: "_removeUploadedVisa",
          value: true,
        });

        this[types.actions.updateVisaRequirementField]({
          visaRequirementID,
          fieldName: "file",
          value: null,
        });
      }
    },

    async onSuccessUploadPassport(response, file, fileList) {
      console.log("[onSuccessUploadPassport]:", response, file, fileList);
      if (this.fileType === "application/pdf") {
        file.url = iconPdf;
      }
      this[types.actions.setIsSaving]({ isSaving: false });
      await waitUntil(() => !this.isSaving);
      const { bookingID, contactID, passportID, relativePath } = response;
      // return;
      // console.log("bookingID, contactID, passportID, relativePath:", bookingID, contactID, passportID, relativePath);
      // console.log("file:", file);

      // uploadPassportUID is an identifier to inform server to update new passport
      // and to allow onRemoveUploadPassport to identify which passport
      this[types.actions.updatePassportField]({
        passportID,
        fieldName: "_uploadPassportUID",
        value: file.uid,
      });

      this[types.actions.updatePassportField]({
        passportID,
        fieldName: "_relativePath",
        value: relativePath,
      });
      this[types.actions.setIsSaving]({ isSaving: false });
    },

    async onRemoveUploadPassport(file, fileList) {
      console.log("[onRemoveUploadPassport]:", file, fileList);
      await waitUntil(() => !this.isSaving);
      let passport = file.passportID
        ? // If the file is pre-populated from server, we can retrieve the passportID directly
          this.passport(file.passportID)
        : // If the file is uploaded by user, we can find the matching passport by file.uid
          this.passports.find(
            (passport) => passport._uploadPassportUID === file.uid,
          );

      if (!passport) {
        console.log("error: Cannot find passportID");
        return;
      }

      const { passportID } = passport;

      this[types.actions.updatePassportField]({
        passportID,
        fieldName: "_uploadPassportUID",
        value: undefined,
      });

      this[types.actions.updatePassportField]({
        passportID,
        fieldName: "_relativePath",
        value: undefined,
      });

      // removeUploadedPassport is a flag to indicate server to remove existing passport
      // Set it to true if there is existing file on the server (ie. passport.file is truthy)
      if (passport.file) {
        this[types.actions.updatePassportField]({
          passportID,
          fieldName: "_removeUploadedPassport",
          value: true,
        });

        this[types.actions.updatePassportField]({
          passportID,
          fieldName: "file",
          value: null,
        });
      }
    },

    onCheckHasSameResidentialAddress: async function (
      contactID,
      fieldName,
      value,
    ) {
      console.log(
        "onCheckHasSameResidentialAddress [contactID, fieldName, value]",
        contactID,
        fieldName,
        value,
      );
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });

      if (value) {
        const {
          mainMailingStreet,
          mainMailingCountry,
          mainMailingCity,
          mainMailingState,
          mainMailingZip,
        } = this.primaryContact;

        this[types.actions.updateContactField]({
          contactID,
          fieldName: "mainMailingStreet",
          value: mainMailingStreet,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "mainMailingCountry",
          value: mainMailingCountry,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "mainMailingCity",
          value: mainMailingCity,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "mainMailingState",
          value: mainMailingState,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "mainMailingZip",
          value: mainMailingZip,
        });
      }
    },
    onCheckHasSameEmergencyContact: async function (
      contactID,
      fieldName,
      value,
    ) {
      console.log(
        "onCheckHasSameEmergencyContact [contactID, fieldName, value]",
        contactID,
        fieldName,
        value,
      );
      await waitUntil(() => !this.isSaving);
      this[types.actions.updateContactField]({
        contactID,
        fieldName,
        value,
      });

      if (value) {
        const {
          emergencyContactFirstName,
          emergencyContactMiddleName,
          emergencyContactLastName,
          emergencyContactPhone,
          emergencyContactRelation,
          emergencyContactEmail,
        } = this.primaryContact;

        this[types.actions.updateContactField]({
          contactID,
          fieldName: "emergencyContactFirstName",
          value: emergencyContactFirstName,
        });
        // this[types.actions.updateContactField]({ contactID, fieldName: 'emergencyContactMiddleName', value: emergencyContactMiddleName })
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "emergencyContactLastName",
          value: emergencyContactLastName,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "emergencyContactPhone",
          value: emergencyContactPhone,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "emergencyContactRelation",
          value: emergencyContactRelation,
        });
        this[types.actions.updateContactField]({
          contactID,
          fieldName: "emergencyContactEmail",
          value: emergencyContactEmail,
        });
      }
    },
    isAquaBlu: function () {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === FACILITY_CODES.AquaBlu;
    },
    isAquaNeraOrAriaAmazon: function () {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      if (
        this.booking.facilityCode === FACILITY_CODES.AquaNera ||
        this.booking.facilityCode === FACILITY_CODES.AriaAmazon
      ) {
        return true;
      }
      return false;
    },
    handleClickROL: function () {
      if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
        window.open("/AQB-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
        window.open("/AQM-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaMekong) {
        window.open("/MAQ-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AriaAmazon) {
        window.open("/AAR-releaseForm(English).pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaNera) {
        window.open("/AQN-releaseForm(English).pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AquaLares) {
        window.open("/AQL-releaseForm.pdf", "_blank");
      }
      return;
    },
    handleClickROLSpanish: function () {
      if (this.booking.facilityCode === FACILITY_CODES.AquaNera) {
        window.open("/AQN-releaseForm(Spanish).pdf", "_blank");
      }
      if (this.booking.facilityCode === FACILITY_CODES.AriaAmazon) {
        window.open("/AAR-releaseForm(Spanish).pdf", "_blank");
      }
      return;
    },

    // checkAllSignedROL: function(contacts){
    //   return (contacts.some(contact => contact.HasSignedReleaseOfLiability === false))
    // },

    // onClickSave(name, contact, index) {
    //   this.$refs[name][index].validate().catch(error => {
    //     console.log('validate error:', error)
    //   })
    //   this.saveContactLoadings[contact.contactID] = true
    //   this.updateContactsAndVisaRequirementsRemote({
    //     contacts: [contact],
    //     visaRequirements: [this.visaRequirementByContactID(contact.contactID)],
    //     showLoader: false,
    //   })
    //     .then(res => {
    //       this.$notify({
    //         title: 'Updated successfully!',
    //         type: 'success',
    //         // desc: nodesc ? '' : 'Here is the notification description. Here is the notification description. '
    //       });
    //     })
    //     .catch(error => {
    //       this.$notify.error({
    //         title: `${error}`,
    //         type: 'error',
    //       });
    //     })
    //     .finally(() => {
    //       this.saveContactLoadings[contact.contactID] = false
    //     })
    // },
    async onClickSaveAndExit(isAutosaving = false) {
      let self = this;
      // Workaround to unknown issue where form.validate doesn't detect invalid form items in production build for some reason.
      if (document.querySelectorAll(".is-error").length === 0) {
        try {
          const res = await self.saveDataToRemote(isAutosaving);
          if (isAutosaving) {
            return res;
          } else {
            self.setIsVisibleDialogSaveAndExit(true);
          }
        } catch (error) {
          self.$message({
            message: error.message || UNHANDLED_ERROR_MESSAGE,
            type: "error",
            duration: 5000,
          });
          // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
          return false;
        }
        return true;
      } else {
        console.log("Invalid field found in form(s)");
        return false;
      }

      // Validates each guest forms and check to see if anything fails validation (specifically for email)
      // this.$refs['formValidate'].forEach(function (form, index, array){
      // form.validate((valid) => {
      //   formsProcessed++;
      //   if (!valid) {
      //     formsValidated = false;
      //   }
      //   if(formsProcessed === array.length && formsValidated) {
      //     self.saveDataToRemote()
      //       .then(res => {
      //         self.setIsVisibleDialogSaveAndExit(true)
      //       })
      //       .catch(error => {
      //         self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
      //       })
      //   }
      // })
      // })
    },
    scrollToFirstError() {
      this.$nextTick(() => {
        // Quick fix workaround to apply error anchoring for passport field
        // TODO: Revamp error anchoring approach for all steps.
        const errorWrapperFields = this.$refs["ae-error-wrapper-field"];

        let errorFields = [];
        for (const form of this.formElements) {
          const fields = form.fields.filter(
            (field) => field.validateState === "error",
          );
          errorFields = errorFields.concat(fields);
        }

        if (errorWrapperFields.length > 0) {
          let errorWrapperFieldsWithErrors = errorWrapperFields.filter(
            (errorWrapperFields) => {
              return errorWrapperFields.$refs["isErrorElement"] !== undefined;
            },
          );

          if (errorWrapperFieldsWithErrors === undefined) {
            return; // Return when no errors found
          }

          if (errorFields.length > 0) {
            errorWrapperFieldsWithErrors =
              errorWrapperFieldsWithErrors.concat(errorFields);
          }

          const sortedByHighestErrorWrapperFieldsWithErrors =
            errorWrapperFieldsWithErrors.sort((a, b) => {
              if (a === undefined || b === undefined) {
                return 0; // Silently throw error since no DOM element present
              }

              const domElementA = a.$el.getBoundingClientRect();
              const domElementB = b.$el.getBoundingClientRect();
              return domElementA.top - domElementB.top;
            });

          const topMostErrorField =
            sortedByHighestErrorWrapperFieldsWithErrors[0];
          if (topMostErrorField !== undefined) {
            topMostErrorField.$el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      });
    },
    async validateForm() {
      let hasErrors = false;

      for (const item of this.formElements) {
        try {
          await item.validate((isValid) => {
            if (!isValid) {
              hasErrors = true;
            }
          }); // Wait for validation to complete
        } catch (error) {
          // Catch validation errors if they occur
          console.log(item);
          hasErrors = true;
        }
      }

      const hasOtherErrors = this.validateWorkAround();

      return hasErrors || !hasOtherErrors;
    },
    async validateIndividualFields(contactID, fieldName) {
      await console.log("this.$refs.formValidate", this.$refs.formValidate);

      const forms = Object.keys(this.$refs).filter(
        (key) => key === "formValidate" + contactID,
      );
      for (const form of forms) {
        const formElement = this.$refs[form][0];
        formElement.validateField(fieldName, (response) => {
          console.log("Validated " + fieldName, response);
        });
      }
    },
    async onClickNext() {
      // let formsValidated = true;
      // let formsProcessed = 0;

      let hasErrors = await this.validateForm();

      if (hasErrors) {
        this.scrollToFirstError();
        return;
      }

      let self = this;

      // Workaround to unknown issue where form.validate doesn't detect invalid form items in production build for some reason.
      self
        .saveDataToRemote()
        .then((res) => {
          self.$router.push("step-3");
        })
        .catch((error) => {
          self.$message({
            message: error.message || UNHANDLED_ERROR_MESSAGE,
            type: "error",
            duration: 5000,
          });
          // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
        });
      // if (document.querySelectorAll('.is-error').length === 0) {
      //
      // } else {
      //   console.log('Invalid field found in form(s)');
      //   self.$message.error(`Please fill in the required fields.`);
      // }

      // Validates each guest forms and check to see if anything fails validation (specifically for email)
      // this.$refs['formValidate'].forEach(function (form, index, array){
      //   form.validate((valid) => {
      //     formsProcessed++;
      //     if (!valid) {
      //       formsValidated = false;
      //     }
      //     if(formsProcessed === array.length && formsValidated) {
      //       self.saveDataToRemote()
      //         .then(res => {
      //           self.$router.push('step-3')
      //         })
      //         .catch(error => {
      //           self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
      //         })
      //     }
      //   })
      // })
    },
    onClickBack() {
      // let formsValidated = true;
      // let formsProcessed = 0;
      let self = this;

      if (document.querySelectorAll(".is-error").length === 0) {
        self
          .saveDataToRemote()
          .then(() => {
            self.$router.back();
          })
          .catch((error) => {
            self.$message({
              message: error.message || UNHANDLED_ERROR_MESSAGE,
              type: "error",
              duration: 5000,
            });
            // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
          });
      } else {
        console.log("Invalid field found in form(s)");
      }

      // // Validates each guest forms and check to see if anything fails validation (specifically for email)
      // this.$refs['formValidate'].forEach(function (form, index, array){
      //   form.validate((valid) => {
      //     formsProcessed++;
      //     if (!valid) {
      //       formsValidated = false;
      //     }
      //     if(formsProcessed === array.length && formsValidated) {
      //       self.saveDataToRemote()
      //         .then(() => {
      //           self.$router.back()
      //         })
      //         .catch(error => {
      //           self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
      //         })
      //     }
      //   })
      // })
    },
    saveDataToRemote(isAutosave = false) {
      const { contacts, visaRequirements, passports } = this;

      let emptyContactIndices = contacts
        .map((contact, index) => {
          const hasPassportNumber =
            !this.canShowPeruvianNationalIDField(contact);
          return !contact.firstName ||
            !contact.lastName ||
            (!contact.passportNumber && hasPassportNumber)
            ? index
            : null;
        })
        .filter((index) => index !== null);

      if (emptyContactIndices.length) {
        const guests = emptyContactIndices.map((index) => `Guest ${index + 1}`);
        const guestsText =
          guests.length <= 1
            ? guests[0]
            : `${guests.slice(0, -1).join(", ")} and ${guests.slice(-1)}`; /* convert [a,b,c] to 'a, b and c' */

        if (!isAutosave) {
          return Promise.reject({
            message: `Please fill in both first name, last name, passport number, and ensure that the release of liability checkbox is filled for ${guestsText}.`,
          });
        }
        return false;
      }

      // Validate passport expiry dates so that they are after the event start date
      let invalidExpiryDateContactNames = contacts
        .filter((contact) => {
          if (!contact.passportExpiryDate) {
            return false;
          }

          const [year, month, date] = contact.passportExpiryDate.split("-");
          const expiryDate = new Date(
            parseInt(year),
            parseInt(month) - 1,
            parseInt(date),
          );
          const eventStartDate = new Date(this.booking.eventStartDate);

          // Passport expiry date is invalid if it is less than eventStartDate
          return expiryDate <= eventStartDate;
        })
        .map((contact) => this.getFullName(contact));

      if (invalidExpiryDateContactNames.length) {
        const guestsText =
          invalidExpiryDateContactNames.length <= 1
            ? invalidExpiryDateContactNames[0]
            : `${invalidExpiryDateContactNames.slice(0, -1).join(", ")} and ${invalidExpiryDateContactNames.slice(-1)}`; /* convert [a,b,c] to 'a, b and c' */
        return Promise.reject({
          message: `Passport Eligibility Error for ${guestsText}: Your passport(s) will expire within 6 months prior to the departure date. Kindly check in again with your updated passport details as soon as possible.`,
        });
      }

      // Validate passport issue date so that they are before current date
      if (!this.booking.isAmazonCruise) {
        let invalidIssueDateContactNames = contacts
          .filter((contact) => {
            if (!contact.passportIssueDate) {
              return false;
            }

            const [year, month, date] = contact.passportIssueDate.split("-");
            const passportIssueDate = new Date(
              parseInt(year),
              parseInt(month) - 1,
              parseInt(date),
            );

            // Passport issued date is invalid if it is after today
            return passportIssueDate > new Date();
          })
          .map((contact) => this.getFullName(contact));

        if (invalidIssueDateContactNames.length) {
          const guestsText =
            invalidIssueDateContactNames.length <= 1
              ? invalidIssueDateContactNames[0]
              : `${invalidIssueDateContactNames.slice(0, -1).join(", ")} and ${invalidIssueDateContactNames.slice(-1)}`; /* convert [a,b,c] to 'a, b and c' */
          return Promise.reject({
            message: `Passport issued date for ${guestsText} ${invalidIssueDateContactNames.length <= 1 ? "is" : "are"} invalid.`,
          });
        }
      }

      const shouldTriggerWorkflow =
        !isAutosave || this.nextSaveRequiresWorkflowTrigger; // fire workflow if user saved or flagged field changed
      const shouldResetOverride =
        this.nextSaveRequiresWorkflowTrigger && shouldTriggerWorkflow;

      return this.updateContactsAndVisaRequirementsRemote({
        contacts,
        visaRequirements: isAutosave ? [] : visaRequirements, // TODO Don't autosave fields with attachments until we find out why attachments are being uploaded repeatedly
        passports: isAutosave ? [] : passports,
        showLoader: !isAutosave,
        workflowTrigger: shouldTriggerWorkflow,
      }).then((result) => {
        if (shouldResetOverride) {
          this.nextSaveRequiresWorkflowTrigger = false;
          this.autosaveIdleDelay = this.defaultAutosaveIdleDelay;
          this.minAutosaveGap = this.defaultMinAutosaveGap;
        }
        return result;
      });
    },
    // Quick fix workaround to apply validation for passport field
    // TODO: Revamp validation approach for all steps.
    validateWorkAround() {
      let isValid = true;
      const emptyFieldsFromValidation = this.getTotalProgressData().emptyFields;

      // Reset model
      this.resetForm();

      emptyFieldsFromValidation.forEach((emptyField) => {
        if (emptyField.field === "passportImage") {
          this.validateConfigs[emptyField.contactID].passportImage = true;
          isValid = false;
        }

        if (emptyField.field === "visaImage") {
          this.validateConfigs[emptyField.contactID].visaImage = true;
          isValid = false;
        }
      });

      return isValid;
    },
    resetForm() {
      this.resetFields(this.validateConfigs);
    },
    resetFields(form) {
      const topLevelKeys = Object.keys(form);
      topLevelKeys.forEach((topLevelKey) => {
        if (typeof form[topLevelKey] !== "boolean") {
          this.resetChildFields(form[topLevelKey]);
        } else {
          form[topLevelKey] = false;
        }
      });
    },
    resetChildFields(form) {
      this.resetFields(form);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.main__guest-listing {
  /* Prevent mid-word wrapping across this component */
  word-break: normal;
  overflow-wrap: normal; /* formerly word-wrap */
  hyphens: none;

  h3 {
    margin-top: 46px;
    margin-bottom: 32px;
    font-size: 20px;
    font-weight: bold;
    line-height: 24px;
    color: $header-text-color;
  }

  .el-form-item {
    margin-bottom: 24px;

    &__label {
      padding-bottom: 4px;
      font-size: 14px;
      line-height: 24px;
    }
  }

  .el-select {
    width: 100%;
  }

  .el-radio__label .el-popover__reference {
    margin-top: 6px;
    @include typo(16);
  }

  hr {
    margin-top: 48px;
    margin-bottom: 48px;
    border-top: 0;
    border-bottom: 1px solid $hr-color;
  }

  .el-upload--visa,
  .el-upload--passport {
    margin-top: 16px;

    .el-upload-list--picture {
      max-width: 352px;
    }

    .el-button {
      padding: 16px;
      @include global-interactive-label-regular-bold;
      color: $white-100;
    }
  }

  .checkbox--samePlan {
    margin-left: 14px;

    .el-checkbox__label {
      font-size: 16px;
      line-height: 24px;
    }
  }
}

.rol-link {
  color: $link-color;
}

.el-collapse-item--guest {
  .el-collapse-item {
    &__header {
      min-height: 90px;
      @include global-paragraph-x-large-bold;
      color: #fff;
    }

    &__arrow {
      position: absolute;
      right: 32px;
      line-height: 29px;
    }
  }

  .guest-number {
    position: absolute;
    top: 50%;
    left: 24px;
    transform: translateY(-50%);
    @include global-paragraph-small-regular;
    color: $white-100;
  }

  .guest-helper {
    margin-bottom: 48px;
    width: 100%;
    @include global-paragraph-small-regular;
    color: $aqua-grey-75;
  }
}

.no-break-words {
  /* Prevent breaking words within this sentence */
  text-align: justify;
  word-break: keep-all;
  overflow-wrap: normal;
  hyphens: none;
}

.last-row {
  .el-form-item {
    margin-bottom: 0;
  }
}

.dialog--visaRequirement {
  .el-dialog {
    min-width: 900px;
    border-radius: 4px;

    &__header {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0;
    }

    &__body {
      padding: 40px 100px;
      @include typo(16);
      color: $text-normal-color;
    }

    &__footer {
      padding: 80px 55px;
    }

    h2 {
      margin-top: 0;
      margin-bottom: 24px;
      @include typo-bold(24);
    }

    /* Allow long URLs to wrap without breaking layout */
    a {
      word-break: break-word; /* legacy support */
      overflow-wrap: anywhere; /* modern browsers */
    }

    .visa-tag {
      padding: 4px 8px;
      margin-bottom: 16px;
      display: inline-block;
      @include typo-bold(16);
      border: 1px solid #a8bac4;
      border-radius: 4px;
      background-color: #f4f4f4;
    }

    .option + .option {
      margin-top: 32px;
    }

    .title {
      margin-bottom: 8px;
      @include typo-bold(14);
    }

    p {
      margin-top: 0;
      margin-bottom: 0;
    }

    ul.visa-bullets {
      /* Align bullet marker with preceding paragraph */
      margin: 8px 0 0 0;
      padding-left: 0;
      list-style-position: inside;
      /* Avoid breaking list text mid-word */
      word-break: normal;
      overflow-wrap: normal;
      hyphens: none;
      /* Match paragraph alignment */
      text-align: justify;
    }

    hr {
      margin-top: 24px;
      margin-bottom: 24px;
    }

    .note--important {
      position: relative;
      margin-top: 24px;
      padding-left: 24px;
      @include typo-bold(16);

      i {
        position: absolute;
        left: 0;
        top: 50%;
        width: 16px;
        height: 16px;
        transform: translateY(-50%);
      }
    }
  }

  /* Override Element UI's `.el-dialog__body { word-break: break-all; }` */
  ::v-deep .el-dialog__body {
    word-break: normal !important;
    overflow-wrap: normal !important;
    hyphens: none !important;
  }
}
</style>

<style lang="scss" scoped>
@import "../scss/color";
@import "../scss/typography";

.residential-address-container {
  margin-top: 32px;
  margin-bottom: 24px;
  @include global-paragraph-medium-bold;
  color: $aqua-grey-100;

  &__notes {
    @include global-paragraph-medium-regular;
  }
}

.small-note {
  @include typo(14);
  font-style: italic;
  color: $text-light-color;
}

.form-subheader {
  margin-top: 0;
  margin-bottom: 24px;
  @include global-paragraph-large-bold;
  color: $aqua-grey-100;
}
</style>



// WEBPACK FOOTER //
// src/components/GuestListingPage.vue